import { PageMode } from '@/main/utils/pageMode';

export enum OperationFlags {
	DEFAULT = 0,
	EDIT = 1,
	VIEW = 2,
	DELETE = 4,
	SELECT = 8,
	PROCESS = 16,
	CREATE = 32,
	EXPORT = 64,
	PRINT = -128,
	PREVIEW = -256,
	CANCEL = 512,
	EDITPCT = 334,
}
/**
 * Returns operations allowed in page mode `mode`.
 *
 * @param mode - page mode.
 * @param operations - operations mask, by default `~0` (all ones in binary).
 */
export function getModeOperations(mode: PageMode, operations: number = ~0): number {
	switch (mode) {
		case PageMode.LIST:
			return operations & (OperationFlags.EDIT | OperationFlags.VIEW | OperationFlags.PROCESS);
		case PageMode.SELECT_LIST:
			return operations & (OperationFlags.SELECT);
		case PageMode.CREATE:
			return 0;
		case PageMode.EDIT:
			return operations & (OperationFlags.EDIT | OperationFlags.VIEW | OperationFlags.PROCESS
				| OperationFlags.CREATE | OperationFlags.EXPORT | OperationFlags.DELETE);
		case PageMode.VIEW:
			return operations & (OperationFlags.VIEW | OperationFlags.EXPORT);
		default:
			return 0;
	}
}
